<template>
  <v-row>
    <div class="col-md-12 home-box">
      <Breadcrumbs :title="'Receipt List'"></Breadcrumbs>
      <ReceiptGrid></ReceiptGrid>
    </div>
    <div class="col-md-12 home-tabs-body">
    </div>
  </v-row>
</template>

<script>

import ReceiptGrid from "@/components/receipts/ReceiptGrid";
import { createNamespacedHelpers } from "vuex";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "Receipts",
  components: {
    ReceiptGrid,
    Breadcrumbs
  },
  computed: {
    ...mapGetters({
      loading: "loading",
      profile: "profile"
    })
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
  },
};
</script>
